
import React from 'react';
import { HelpCircle } from 'lucide-react';

const UlosottoFaqSection: React.FC = () => {
  return (
    <div className="bg-blue-50 p-6 rounded-lg border border-blue-200 mb-8">
      <h3 className="text-lg font-semibold mb-3 flex items-center"><HelpCircle size={20} className="mr-2 text-blue-600" /> Usein kysyttyä ulosotosta</h3>
      <div className="space-y-4">
        <div>
          <p className="font-medium">Kuinka kauan ulosotto kestää?</p>
          <p>Ulosotto jatkuu, kunnes velka on maksettu kokonaan, tai se vanhenee. Tavallinen velka vanhenee yleensä 15 tai 20 vuodessa ulosottoperusteen päivämäärästä.</p>
        </div>
        <div>
          <p className="font-medium">Voiko ulosottoa välttää muuttamalla ulkomaille?</p>
          <p>Ulosottovelkoja voidaan joissain tapauksissa periä myös ulkomailta, erityisesti EU-maissa. Lisäksi velkojilla on mahdollisuus jatkaa perintää, kun palaat Suomeen.</p>
        </div>
        <div>
          <p className="font-medium">Miten korona on vaikuttanut ulosottoon?</p>
          <p>Koronatilanteen vuoksi joitakin ulosottotoimia on voitu lykätä, ja maksujärjestelyihin on voitu suhtautua joustavammin. Tilanne voi kuitenkin muuttua, joten ota aina yhteyttä omaan ulosottomieheen.</p>
        </div>
      </div>
    </div>
  );
};

export default UlosottoFaqSection;
